module.exports = __webpack_public_path__ + "static/90aff6d049a8712ac69a8e123ab28c3e9c88d0eb49f002a55185401680304e64-e940c2719d4510d70f5ea4fcc0dec1c6.png";